import {Injectable} from '@angular/core';
import {Account} from '../../domain/model/account.model';

@Injectable()
export class AccountCacheService {
  readonly MAX_SIZE = 25;
  private readonly accounts = new Map<string, Account>();

  get(id: string): Account | undefined {
    return this.accounts.get(id);
  }

  getAll(): Account[] {
    return Array.from(this.accounts.values());
  }

  set(account: Account): void {
    this.accounts.set(account?.id, account);
    this.enforceMaxSize();
  }

  populate(accounts: Account[]): void {
    accounts.forEach(account => this.accounts.set(account?.id, account));
    this.enforceMaxSize();
  }

  clear(): void {
    this.accounts.clear();
  }

  private enforceMaxSize(): void {
    if (this.accounts.size <= this.MAX_SIZE) {
      return;
    }

    const [oldestKey] = this.accounts.keys();

    this.accounts.delete(oldestKey);
  }
}
